export interface DynamicConfig {
    apiUrl: string;
    clientId: string;
  }
  
  export const defaultConfig: DynamicConfig = {
    apiUrl: "",
    clientId: "00000000-0000-0000-0000-000000000000"
  };
  
  class GlobalConfig {
    config: DynamicConfig = defaultConfig;
  }
  
  export const globalConfig = new GlobalConfig();
  
  export const globalConfigUrl = "config.json";
